import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const WoBulkUpdateService = {

  // Transaction list — DevExtreme DataSource for gc-data-grid
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  // Get single transaction (full state) — for draft edit/load
  getTransaction(transactionId) {
    const requestParams = {
      url: `api/WoBulkUpdateTransactionList`,
      filter: "TransactionId eq " + transactionId + "",
    }
    return ApiService.oDataGet(requestParams);
  },

  // Get transaction record (audit/review mode) — dedicated endpoint with WoOutcomes
  getTransactionRecord(transactionId) {
    return ApiService.get(`api/WoBulkUpdate/${transactionId}`);
  },

  // Save draft (create or overwrite)
  saveDraft(payload) {
    return ApiService.post("api/WoBulkUpdate/SaveDraft", payload);
  },

  // Cancel a draft
  cancel(transactionId) {
    return ApiService.post(`api/WoBulkUpdate/Cancel/${transactionId}`);
  },

  // Execute WO search
  search(payload) {
    return ApiService.post("api/WoBulkUpdate/Search", payload);
  },

  // Compute per-WO line diff
  computeDiff(payload) {
    return ApiService.post("api/WoBulkUpdate/ComputeDiff", payload);
  },

  // Check for stale diff
  checkStaleDiff(payload) {
    return ApiService.post("api/WoBulkUpdate/CheckStaleDiff", payload);
  },

  // Execute bulk update (commit transaction)
  apply(transactionId) {
    return ApiService.post("api/WoBulkUpdate/Apply", { TransactionId: transactionId });
  },

};

export { WoBulkUpdateService };
